var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LLButton',{staticClass:"ForumResponseSaveButton",attrs:{"tertiary-dark":"","small":"","loading":_vm.loading},on:{"click":_vm.onToggleSave},scopedSlots:_vm._u([{key:"icon-left",fn:function(){return [(_vm.isSaved)?_c('SavedPostsFilledIcon',{staticClass:"ForumResponseSaveButton__icon"}):_c('SavedPostsIcon')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }